import * as TYPES from '../types';

export default (state = {editable:false}, action) => {
  switch (action.type) {
    case TYPES.SET_EDITABLE_MANAGER:
      return {...action.editable};
    default:
      return state;
  }
};
